<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right" v-if="$permission.canWrite()">
        <el-button type="primary" plain @click="reviewAll">批量审核</el-button>
        <el-button type="danger" plain @click="backAll">批量弃审</el-button>
        <el-button type="success" plain @click="onImprot">导入</el-button>
        <el-button type="primary" @click="create" icon="el-icon-plus">添加</el-button>
      </template>
      <template slot="column">
        <el-table-column label="操作" fixed="right" align="center" width="100">
          <template slot-scope="{row}">
            <el-button v-if="$permission.canWrite() && row.Status !== 2" @click="edit(row)" type="text">编辑</el-button>
            <el-button v-if="$permission.canReview() && row.Status == 2" type="text" @click="edit(row)">查看</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <import-dialog ref="importDialog" @upload-success="reload" />
  </div>
</template>
<script>
import curdMixins from "@/mixins/trend/curd";
import list from '@/components/business/stock/otherinbound/list'
import importDialog from '@/components/business/stock/otherinbound/importDialog'

export default {
  name: "bom",
  mixins: [curdMixins],
  components: {
    list,
    importDialog,
  },
  data() {
    return {
      api: require("@/api/stock/stInDoc").default,
    }
  },
  methods: {
    onImprot() {
      this.$refs.importDialog.open();
    },
    edit({ DocId }) {
      let id = DocId;
      this.api.info(id).then(res => {
        if (res.Code === 0) {
          this.toURL({
            name: 'editotherinbound',
            params: {
              type: 'edit',
              data: res.Data
            }
          })
        } else {
          this.$message({ type: 'warning', message: res.Msg })
        }
      })
    },
    create() {
      this.toURL({
        name: 'editotherinbound',
        params: {
          type: 'create'
        }
      })
    },
    toURL(o) {
      this.$router.push(o)
    },
    reviewAll() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要审核的数据");
        return;
      }
      var that = this;
      this.$confirm("确认审核所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let ids = rows.map((item) => item.DocId);
        this.api.reviewAll({ ids }).then(res => {
          this.$message({
            showClose: true,
            duration: 0,
            dangerouslyUseHTMLString: true,
            message: `<div class="my-message">${res.Msg}</div>`,
            onClose: () => {
              that.reload();
            }
          });
        })
      }).catch(() => { });
    },
    backAll() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要弃审的数据");
        return;
      }
      var that = this;
      this.$confirm("确认弃审所选的数据吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let ids = rows.map((item) => item.DocId);
        this.api.backAll({ ids }).then(res => {
          this.$message({
            showClose: true,
            duration: 0,
            dangerouslyUseHTMLString: true,
            message: `<div class="my-message">${res.Msg}</div>`,
            onClose: () => {
              that.reload();
            }
          });
        })
      }).catch(() => { });
    }
  }
};
</script>